import CatProfileEmptyIcon from 'assets/icons/cat-profile-empty.svg';
import CatProfileFilledIcon from 'assets/icons/cat-profile-filled.svg';
import cn from 'classnames';
import { PetType } from 'constants/pet-type';
import DogProfileEmptyIcon from 'assets/icons/dog-profile-empty.svg';
import DogProfileFilledIcon from 'assets/icons/dog-profile-filled.svg';
import Image from 'next/legacy/image';
import { FC, FunctionComponent, SVGAttributes } from 'react';
import { DogProfile } from 'types/pet-profile';
import { BREED_IMAGE_MAP } from '../../constants';
import {
  getPetProfileIllustrationType,
  PetProfileIllustrationType,
} from '../../utils/get-pet-profile-illustration-type';

const PET_PROFILE_ICON_MAP: Partial<
  Record<PetProfileIllustrationType, FunctionComponent<SVGAttributes<SVGElement>>>
> = {
  [PetProfileIllustrationType.CatEmpty]: CatProfileEmptyIcon,
  [PetProfileIllustrationType.CatFilled]: CatProfileFilledIcon,
  [PetProfileIllustrationType.DogEmpty]: DogProfileEmptyIcon,
  [PetProfileIllustrationType.DogFilled]: DogProfileFilledIcon,
};

interface PetProfileIllustrationProps {
  isEmpty: boolean;
  breed?: DogProfile['selectedBreed'];
  petType: PetType;
  className: string;
  imageSize: number;
}

const PetProfileIllustration: FC<PetProfileIllustrationProps> = ({
  isEmpty,
  breed,
  petType,
  className,
  imageSize,
  ...rest
}) => {
  const illustrationType = getPetProfileIllustrationType({ breed, petType, isEmpty });
  const breedImage =
    illustrationType === PetProfileIllustrationType.Breed && breed
      ? {
          src: BREED_IMAGE_MAP[breed],
          alt: `Breed ${breed}`,
        }
      : null;
  const Icon = PET_PROFILE_ICON_MAP[illustrationType];

  if (!breedImage && !Icon) return null;

  return (
    <div
      {...rest}
      className={cn(className, 'shrink-0', breedImage && 'overflow-hidden rounded-full')}
      data-illustration-type={illustrationType}
    >
      {breedImage ? (
        <Image {...breedImage} width={imageSize} height={imageSize} />
      ) : (
        Icon && <Icon className="h-full w-full" />
      )}
    </div>
  );
};

export default PetProfileIllustration;
